<template>
  <ion-tabs @ionTabsWillChange="onTabsWillChange">
    <ion-router-outlet></ion-router-outlet>

    <ion-tab-bar slot="bottom">
      <ion-tab-button
        v-for="t in TABS"
        :key="t.tab"
        :tab="t.tab"
        :href="`/tabs/${t.tab}`"
      >
        <ion-icon
          :icon="t.icon"
          class="text-xl transition-all duration-200"
          :class="selectedTab === t.tab
            ? `text-indigo-400 translate-y-1.5 ${t.activeIcon}`
            : `text-white ${t.idleIcon}`"
        ></ion-icon>
        <ion-label
          class="text-[10px] mb-0 transition-all duration-200"
          :class="selectedTab === t.tab ? 'translate-y-2 opacity-0' : 'translate-y-0 opacity-100'"
        >{{ t.label }}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</template>

<script setup>
import { ref } from 'vue'
import {
  IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonRouterOutlet,
} from '@ionic/vue'
import { pulseOutline, playOutline, settingsOutline, musicalNotesOutline } from 'ionicons/icons'

// activeIcon / idleIcon are written out per tab so no two utilities
// fight over --tw-scale-x.
const TABS = [
  { tab: 'tuner',     
    label: 'Tuner',     
    icon: pulseOutline,
    activeIcon: 'scale-150',                   
    idleIcon: 'scale-100' 
  },
  { tab: 'chords',     
    label: 'Chords',     
    icon: musicalNotesOutline,
    activeIcon: 'scale-150',                   
    idleIcon: 'scale-100' 
  },
  { 
    tab: 'metronome', 
    label: 'Metronome', 
    icon: playOutline,
    activeIcon: 'scale-150 rotate-[270deg] duration-[2000ms]',    
    idleIcon: 'scale-100' 
  },
  { 
    tab: 'settings',      
    label: 'Settings',      
    icon: settingsOutline,
    activeIcon: '-scale-x-150 scale-y-150',    
    idleIcon: '-scale-x-100 scale-y-100' 
  },
]

const selectedTab = ref('tuner')

// Fires for every tab change — taps, back button, deep links, programmatic
// navigation — so the indicator can't drift out of sync with the router.
function onTabsWillChange(event) {
  selectedTab.value = event.tab
}
</script>

<style scoped>


ion-tab-bar {
  --background: #000;
  --border: none;
  padding: 0.5rem 0.5rem calc(0.5rem + var(--ion-safe-area-bottom, 0px));
  box-shadow: none;
  border-top: none;
}
</style>